import React, { useState, useEffect } from "react";
import "../styles/EducationPage.css";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import SEO from "../components/SEO";

import * as productService from "../_services/products.service";

export default function MagyneSchoolPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [product, setProduct] = useState(location.state?.product || null);
  const params = new URLSearchParams(location.search);
  const proceedTo = params.get("proceedTo") || "register";
  const tenantId = params.get("tenantId") || null;
  const productId = params.get("productId") || "2cff8f59-b62c-4a63-84a9-f5fb3e5714c5";

  const handleNavigate = () => {
    navigate(`/pricing/?productId=${product.productId}&proceedTo=${proceedTo}&tenantId=${tenantId}`, {state:{product}})
  }

  useEffect(() => {
    const fetchProduct = async () => {
      if (!product && productId) {
        setLoading(true);
        try {
          const getProduct = await productService.get({
            productId,
            status: "all"
          });
          if(!getProduct.data?.length){
            setProduct(null);
          }
          setProduct(getProduct.data[0]);
        } catch (error) {
          toast.error(error.messaage || "Failed to fetch product details.");
        } finally {
          setLoading(false);
        }
      }
    }

    fetchProduct();
  }, [product, productId]);

  return (
    <>
      <SEO
        title="Magyne School | School Management Software in Zambia"
        description="Magyne School is school management software for student administration, academics, attendance, examinations, billing and payments."
        path="/solutions/school"
      />
      
      <div className="education-page">
        {/* Hero */}
        <div className="bg-blobs">
          <div className="blob blob1"></div>
          <div className="blob blob2"></div>
          <div className="blob blob3"></div>
        </div>

        {
          loading
          ? 
            <div>
              <div className="spinner"></div>
              <p className="text-center">
                Loading products. <br/>
                Please wait...
              </p>
            </div>
          : !loading && product 
          ? (
            <>
            <section
              className="education-hero"
              style={{
                backgroundImage: `url(${product.img})` || "url('/images/school.jpg')",
              }}
            >
              <div className="education-hero-overlay">
                <h1>Magyne School Administration Software</h1>
                
                <p>
                  Magyne School helps schools manage students, guardians,
                  classes, subjects, attendance, examinations, academic records,
                  billing and payments from one platform.
                </p>
                <button className="cta-btn" onClick={() => {handleNavigate()}}>Choose a Package</button>
              </div>
            </section>

            <section className="healthcare-features">
              <h2>Key Features</h2>
              <div className="features-grid">
              <div className="feature-card">
                <h3>Student Management</h3>
                <p className="details">
                  Manage enrollments, track retention rates, and handle student
                  billing with ease.
                </p>
                <p className="benefits">
                  Benefits: Accurate records, reduced paperwork, and timely billing.
                </p>
              </div>

              <div className="feature-card">
                <h3>Exams</h3>
                <p className="details">
                  Schedule exams, record grades, and generate performance reports
                  effortlessly.
                </p>
                <p className="benefits">
                  Benefits: Centralized grading, quicker feedback, and data-driven
                  academic planning.
                </p>
              </div>

              <div className="feature-card">
                <h3>Staff Management</h3>
                <p className="details">
                  Organize staff records performance evaluations in
                  one place.
                </p>
                <p className="benefits">
                  Benefits: Efficient HR processes and improved accountability.
                </p>
              </div>

              <div className="feature-card">
                <h3>Finance</h3>
                <p className="details">
                  Full accounting suite to manage budgets, payments, Payroll, and financial
                  reporting.
                </p>
                <p className="benefits">
                  Benefits: Clear financial oversight and audit-ready records.
                </p>
              </div>
                
              </div>
            </section>
            

            {/* CTA */}
            <section className="education-cta">
              <h2>Ready To Transform Your Institution?</h2>
              <p>
                Empower your school / college / university with Magyne, streamline tasks and open the door to greater success.
              </p>
              <button className="cta-btn" onClick={() => handleNavigate()}>Choose a Package</button>
            </section>
            </>
          ) 
          : !loading && !product && (
            <>
            <div className="login-card mt-lg-5 mb-lg-5">
              <div className="logo-container">
              <h3 className="page-title mb-2">Invalid product.</h3>
              <p>Unknown product name. please pick a valid industry in which you business belongs.</p>
                <p className="register-text">
                  We have our product here{" "}
                  <a href="/products">See products</a>
                </p>
            </div>
          </div>
          </>
          )
        }
      </div>
    </>
  );
}
